import React from 'react';
import { Button } from 'reactstrap';
import Cookies from '../../../util/cookies';
import getConfig from 'next/config';

const config = getConfig().publicRuntimeConfig;

const buttonStyle = {
	padding: '0.75rem',
};

const iconStyle = {
	width: '18px',
	height: '18px',
	marginRight: '0.5rem',
};

const onGoogleButtonClick = (e) => {
	Cookies.save('redirect_url', window.location.href);
	if (window.eventDispatcher) {
		window.eventDispatcher.dispatchEvent('loginInitiated', {method: 'google'}, {amplitude: true});
	}
	return true;
};

const onFacebookButtonClick = (e) => {
	Cookies.save('redirect_url', window.location.href);
	if (window.eventDispatcher) {
		window.eventDispatcher.dispatchEvent('loginInitiated', {method: 'facebook'}, {amplitude: true});
	}
	return true;
};

const SocialButtons = ({ text }) => (
	<div style={{ width: '100%' }}>
		<div style={{ width: '100%' }}>
			<a href="/auth/oauth/facebook">
				<Button className="btn btn-facebook btn-full-width" style={buttonStyle} onClick={onFacebookButtonClick} name="facebook" >
					<img src={`${config.cdnUrl}/static/icons/facebook.svg`} alt="Facebook" style={iconStyle} />
					{text} with Facebook
				</Button>
			</a>
		</div>
		<div style={{ marginTop: '1rem', width: '100%' }}>
			<a href="/auth/oauth/google">
				<Button outline color="dark" className="btn btn-full-width" style={buttonStyle} onClick={onGoogleButtonClick} name="google" >
					<img src={`${config.cdnUrl}/static/icons/google.svg`} alt="Google" style={iconStyle} />
					{text} with Google
				</Button>
			</a>
		</div>
	</div>
);

export default SocialButtons;
